import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loading from './Loading';
import Routing from '../../routing/Routing';
import ErrorRouting from '../../routing/ErrorRouting';
import navigationService from '../../services/NavigationService';
import uiService from '../../services/UIService';

class AppLoaderClass extends React.Component {
    static propTypes = {
        appReady: PropTypes.bool,
        criticalErrorOccurred: PropTypes.bool,
        store: PropTypes.object.isRequired,
    };

    componentDidMount() {
        uiService.setTestPlayerTheme();
    }

    render() {
        const { appReady, criticalErrorOccurred } = this.props;
        if (criticalErrorOccurred) {
            return <ErrorRouting store={this.props.store} />;
        }

        navigationService.clearErrorRouting(window.location);
        if (appReady) {
            return <Routing store={this.props.store} />;
        }

        return window.playerStartupConfig && window.playerStartupConfig.shouldUseNewLoader
            ? null // return nothing when new player loader is used because it has own loader
            : <Loading />;
    }
}

function mapStateToProps(state) {
    return {
        appReady: state.session.appReady,
        criticalErrorOccurred: state.session.criticalErrorOccurred,
    };
}

const AppLoader = connect(mapStateToProps)(AppLoaderClass);
export default AppLoader;
